export default __webpack_public_path__ + "static/media/setion05_kv02_m.50d58b4d.png";